const USE_LOCAL_ENV = false;

const LOCAL_SOCKET_URL = 'http://localhost:8585';
const LOCAL_API_URL = 'http://localhost:8585/v1/';

const PRODUCTION_SOCKET_URL = 'https://api.ops.holeopener.com';
const PRODUCTION_API_URL = 'https://api.ops.holeopener.com/v1/';

export const SOCKET_URL = USE_LOCAL_ENV
  ? LOCAL_SOCKET_URL
  : PRODUCTION_SOCKET_URL;
export const API_BASE_URL = USE_LOCAL_ENV ? LOCAL_API_URL : PRODUCTION_API_URL;

export const getSocketUrl = (useLocal: boolean = USE_LOCAL_ENV) =>
  useLocal ? LOCAL_SOCKET_URL : PRODUCTION_SOCKET_URL;

export const getApiUrl = (useLocal: boolean = USE_LOCAL_ENV) =>
  useLocal ? LOCAL_API_URL : PRODUCTION_API_URL;

export const CONFIG_INFO = {
  USE_LOCAL_ENV,
  CURRENT_SOCKET_URL: SOCKET_URL,
  CURRENT_API_URL: API_BASE_URL,
  ENVIRONMENT: USE_LOCAL_ENV ? 'LOCAL' : 'PRODUCTION'
};
